import { useState } from "react";
import { Plus, Minus, HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "What ages does LP Foundation serve?",
    a: "Our SEAA programs are designed for youth ages 8–16. If you're unsure whether a program is a fit for your child, reach out and we'll help you find the right one.",
  },
  {
    q: "How much do the programs cost?",
    a: "We work hard to keep our programs accessible to every family regardless of income. Costs vary by program and location, and scholarships are often available. Submit an enrollment inquiry and we'll share current details for your child's program of interest.",
  },
  {
    q: "Where are your programs and camps located?",
    a: "We partner with community sites including the Boys & Girls Club, recreation centers, and public libraries — most recently at Fulton County Library, the East Point Recreation Center, and the Augusta Boys & Girls Club. Contact us for the schedule near you.",
  },
  {
    q: "How do I enroll my child?",
    a: "Head to our Get Involved page and fill out the 'Enroll Your Child' form. Tell us your child's age and the program you're interested in, and our team will follow up with enrollment details.",
  },
  {
    q: "Can I volunteer or mentor?",
    a: "Absolutely — we're always looking for caring adults to mentor, assist with instruction, and help at events. Fill out the volunteer form on our Get Involved page and we'll reach out.",
  },
  {
    q: "Are donations tax-deductible?",
    a: "Yes. LP Foundation is a registered 501(c)(3) nonprofit, so your one-time and monthly gifts are tax-deductible to the extent allowed by law.",
  },
  {
    q: "How can my school, city, or business partner with you?",
    a: "We love building partnerships with schools, recreation centers, cities, and corporate sponsors. Visit our Partner page to start the conversation.",
  },
];

function Item({ q, a, open, onToggle, idx }) {
  return (
    <div className="border-b border-slate-200">
      <button
        type="button"
        onClick={onToggle}
        data-testid={`faq-question-${idx}`}
        className="flex w-full items-center justify-between gap-4 py-5 text-left"
      >
        <span className="font-display text-lg font-bold text-brandnavy">{q}</span>
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-orange-50 text-accent">
          {open ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
        </span>
      </button>
      {open && (
        <p data-testid={`faq-answer-${idx}`} className="pb-6 pr-12 text-slate-600 leading-relaxed">
          {a}
        </p>
      )}
    </div>
  );
}

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-white py-20" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center">
          <span className="mx-auto inline-flex items-center gap-2 text-accent">
            <HelpCircle className="h-5 w-5" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase">Questions?</span>
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-black tracking-tight text-brandnavy">
            Frequently asked questions
          </h2>
          <p className="mt-3 text-slate-600">Everything parents and partners ask us most.</p>
        </div>
        <div className="mt-10">
          {FAQS.map((f, i) => (
            <Item key={i} idx={i} q={f.q} a={f.a} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </div>
    </section>
  );
}
